import { render, staticRenderFns } from "./schemaFields.vue?vue&type=template&id=2d5d598a&scoped=true"
import script from "./schemaFields.vue?vue&type=script&lang=js"
export * from "./schemaFields.vue?vue&type=script&lang=js"
import style0 from "./schemaFields.vue?vue&type=style&index=0&id=2d5d598a&prod&lang=css"
import style1 from "./schemaFields.vue?vue&type=style&index=1&id=2d5d598a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d598a",
  null
  
)

export default component.exports